import {isColor} from "./GUIUtilities";
import * as ShowImageIn from "../constants/ShowImageIn";
import * as ObjectChecker from "../common/NamaCommon";
import * as ts from "../common/Translator";
import {addImgPartToName} from "./AttachmentLinkUtil";

export function calcImage(data) {
    let recordId = data.imageRecordId;
    let entityType = data.imageRecordEntityType;
    let displayString = calcDisplayStr(data);
    let object = data.value;
    let displayStr = `<span > ${displayString} </span>`;
    return addImgPartToName(entityType, recordId, displayStr, ShowImageIn.Suggestion, object);
}

export function displayStringOfSuggestionItem(data) {
    let replacementString = data.text ? data.text.code : data.code;
    let displayString = calcImage(data);
    if (replacementString && isColor(replacementString))
        return `<span style='background-color: ${replacementString};${displayString} </span>`;
    return displayString;
}

function calcDisplayStr(item) {
    let text = item.text;
    if (!text)
        return "";
    let code = ObjectChecker.getFirstNotEmptyObj(item.displayCode, text.code);
    let name = ts.selectNameBasedOnLang(text.name1, text.name2);
    if (ObjectChecker.areEqual(code, name) || ObjectChecker.isAnyEmptyOrNull(code, name))
        return ObjectChecker.getFirstNotEmptyObj(code, name);
    return code + " (" + name + ")";
}